import { CustomParseFieldProps } from "@opendash/plugin-parse";
import React from "react";
import StatusTag from "./StatusTag";
type ParseOrderStatusTagProps = CustomParseFieldProps<any>;
const ParseOrderStatusTag = ({
  parseObject,
  value,
  fieldname,
  setValue,
}: ParseOrderStatusTagProps) => {
  return <StatusTag status={parseObject?.get("status")}></StatusTag>;
};

export default ParseOrderStatusTag;
export type { ParseOrderStatusTagProps };
